import './critical.scss';
// import 'shared-tokens/src/index.scss';
// import '@client/style/create/critical.scss';

export default clb => clb();
